import React from "react";
import { Card, CardHeader, Grid, Typography } from "@sumprio/ui";

const headerBorderStyle: React.CSSProperties = {
  borderBottom: "1px solid var(--color-border-neutral-secondary, #e5e7eb)",
};

export interface SectionCardProps {
  title: string;
  headerLeft?: React.ReactNode;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export default function SectionCard({
  title,
  headerLeft,
  headerRight,
  children,
  className,
  style,
}: SectionCardProps) {
  return (
    <Card style={{ marginBottom: 24, overflow: "visible", ...style }} className={className}>
      <CardHeader style={headerBorderStyle}>
        <Grid
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap="md"
        >
          <Grid display="flex" alignItems="center" gap="md" flexWrap="wrap">
            <Typography variant="heading" headingSize="xxs" headingWeight="medium">
              {title}
            </Typography>
            {headerLeft}
          </Grid>
          {headerRight}
        </Grid>
      </CardHeader>
      {children}
    </Card>
  );
}
